import * as React from "react"

import {
  UWPNotifier,
  OutputAction,
  InputAction,
  DownloadStatusPayload,
  DownloadStatus
} from '@shared'

// TODO(PVWinApp-394): Move to DVUI
import {
  DownloadButtonWithLabel,
  DownloadButton,
  DownloadLabels
} from "../../../DVWebNodeSPA/components/DownloadButton"

export interface IDownloadActionProps {
  labels?: DownloadLabels
  downloadURL?: string
  titleID?: string
  withLabel?: boolean
}

type DownloadActionState = {
  downloadStatus: DownloadStatus
  downloadProgress: number
}

export class DownloadAction extends React.Component<
  IDownloadActionProps,
  DownloadActionState
> {
  unsubscribe: () => void

  state = {
    downloadStatus: DownloadStatus.IDLE,
    downloadProgress: 0
  }

  triggerDownload = (e: React.MouseEvent) => {
    this.setState({
        downloadStatus: DownloadStatus.WAITING
    })
    UWPNotifier.getInstance().publish(OutputAction.Download, {
      titleId: this.props.titleID
    })
    e.preventDefault()
  }

  cancelOrPause = (e: React.MouseEvent) => {
    // TODO(PVWinApp-384): Build a Cancel or Pause Modal
    UWPNotifier.getInstance().publish(OutputAction.PauseDownload, {
      titleId: this.props.titleID
    })
    e.preventDefault()
  }

  handleClick = global.__NATIVEAPP__
    ? this.state.downloadStatus === DownloadStatus.IDLE
      ? this.triggerDownload
      : this.cancelOrPause
    : undefined

  downloadChanged = (payload: DownloadStatusPayload) => {
    const { state = DownloadStatus.IDLE, progress = 0, titleId } = payload

    if (titleId && titleId === this.props.titleID) {
      this.setState({
        downloadStatus: DownloadStatus[state as keyof typeof DownloadStatus],
        downloadProgress: progress
      })
    }
  }

  componentDidMount() {
    this.unsubscribe = UWPNotifier
      .getInstance()
      .subscribe(InputAction.DownloadStatus, this.downloadChanged)
  }

  componentWillUnmount() {
    this.unsubscribe && this.unsubscribe()
  }

  render() {
    const { downloadURL, withLabel } = this.props

    if (!downloadURL) {
      return null
    }

    const downloadButtonProps = {
      onClick: this.handleClick,
      href: downloadURL,
      progress: this.state.downloadProgress,
      status: this.state.downloadStatus,
      // TODO(PVWinApp-385): Localize Strings
      labels: {
        IDLE: 'Download',
        WAITING: 'Waiting',
        QUEUED: 'Queued',
        DOWNLOADING: 'Downloading',
        PAUSED: 'Resume',
        ERROR: 'Error',
        COMPLETED: 'Downloaded'
      }
    }

    return (
      <div
        className="avu-full-width-phablet"
        data-automation-id="download-button"
      >
        {withLabel ? (
          <DownloadButtonWithLabel
            {...downloadButtonProps}
            forceDoubleHeight={true}
          />
        ) : (
          <DownloadButton {...downloadButtonProps} />
        )}
      </div>
    )
  }
}
